import { apiRoutes } from '../../api-routes';
import { httpClient } from '../../util';

type Response = {
  code: string;
  description: string;
  http_code: number;
  internal: string;
  title: string;
};

export const deleteUserPlaceFn = async (id: string) => {
  const response = await httpClient.delete<Response>(
    `${apiRoutes.place.savedPlaces}/${id}`
  );
  return response.data;
};
